module.exports = __webpack_public_path__ + "media/images/socials/stackoverflow-2f4ee8fbc0f32e80ad0f887b704a7f1e.png";